module.exports = __webpack_public_path__ + "img/white-check.d1ea0a3b.svg";